import { colors, fontSize, fontWeight, media, radius, spacer } from 'settings/style';
import styled from 'styled-components';

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer.lg};
  margin-top: ${spacer.lg};
  width: 100%;
`;

export const ProfileTop = styled.div`
  background: ${colors.grey200};
  border: 1px solid #e4e7ec;
  border-radius: ${radius.lg};
  padding: ${spacer.lg};
`;

export const ProfileHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacer.lg};

  ${media.lg`
    flex-wrap: wrap;
  `}
`;

export const ProfileInfoWrap = styled.div`
  flex: 1;
  min-width: 240px;
`;

export const ProfileHeading = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacer.sm};
`;

export const ProfileName = styled.h2`
  margin: 0;
  font-size: 32px;
  line-height: 1.2;
  color: ${colors.grey900};
  font-family: 'Cormorant Garamond', Georgia, serif;
`;

export const ProfileTag = styled.span`
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 ${spacer.sm};
  border-radius: 999px;
  background: #f8e39a;
  color: #725200;
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.bold};
`;

export const UserIdText = styled.div`
  margin-top: ${spacer.lg};
  color: ${colors.gray700};
  font-size: ${fontSize.md};
`;

export const MetaRow = styled.div`
  margin-top: ${spacer.lg};
  display: flex;
  flex-wrap: wrap;
  gap: ${spacer.md};
`;

export const MetaText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${colors.gray700};
  font-size: ${fontSize.md};
`;

export const ProfileActionWrap = styled.div`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: ${spacer.xs};

  ${media.lg`
    margin-left: 0;
  `}
`;

export const ProfileBody = styled.div`
    margin-top: ${spacer.lg};
`;

export const ProfileCard = styled.section`
  background: ${colors.grey200};
  border: 1px solid #e4e7ec;
  border-radius: ${radius.lg};
  padding: ${spacer.lg};

  h3 {
    margin: 0 0 ${spacer.md};
    color: ${colors.grey900};
    font-size: 28px;
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-weight: 500;
  }
`;

export const ProfileSubLine = styled.div`
  font-size: ${fontSize.md};
  color: ${colors.gray800};
  margin-bottom: ${spacer.sm};
`;

export const ProfileDescription = styled.p`
  margin: 0;
  color: ${colors.gray700};
  line-height: 1.75;
`;

export const SettingsCard = styled(ProfileCard)`
  h3 {
    font-size: 24px;
  }
`;

export const SettingsTopGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacer.md};
  padding-bottom: ${spacer.sm};
  border-bottom: 1px solid #eaecf0;

  ${media.md`
    grid-template-columns: 1fr;
    gap: ${spacer.sm};
  `}
`;

export const SettingsTopItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacer.sm};
  ${media.md`
    justify-content: space-between;
  `}
`;

export const SettingsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacer.sm};
  padding: ${spacer.sm} 0;
  border-top: 1px solid #eaecf0;

  ${media.md`
    justify-content: space-between;
  `}

  &:first-of-type {
    border-top: 0;
    padding-top: 0;
  }
`;

export const SettingsLabel = styled.span`
  color: ${colors.gray800};
  font-size: ${fontSize.sm};
`;

export const SettingsValueWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacer.sm};
`;

export const EditProfileModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacer.md};

  .ant-form-item {
    margin-bottom: 18px;
  }

  .ant-form-item-label > label {
    color: #4b5563;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.3;
    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  }

  .ant-form-item-label {
    padding-bottom: 6px;
  }

  .auth-input-text {
    border-radius: 8px;
    border: 1px solid #e4e7ec;
    padding: 10px 12px;
    font-size: 0.9375rem;
    color: ${colors.grey900};
    background: #fff;

    &:hover {
      border-color: #1a2744;
    }

    &:focus,
    &.ant-input-focused {
      border-color: #1a2744;
      box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.18);
    }

    &::placeholder {
      color: #9ca3af;
    }
  }

  .auth-date-input.ant-picker {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #e4e7ec;
    padding: 10px 12px;
    background: #fff;

    &:hover {
      border-color: #1a2744;
    }

    &.ant-picker-focused {
      border-color: #1a2744;
      box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.18);
    }

    input {
      color: ${colors.grey900};

      &::placeholder {
        color: #9ca3af;
      }
    }
  }
`;

export const EditProfileAvatarWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${spacer.sm};
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
`;

export const EditProfileNameRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacer.sm};

  ${media.md`
    grid-template-columns: 1fr;
  `}
`;